import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import {
  PublicProofOfDeliveryInitialState,
  PublicProofOfDeliveryLoad,
  PublicProofOfDeliverySave,
  PublicProofOfDeliveryDownloadFile,
  PublicProofOfDeliveryFeedback,
} from './public-proof-of-delivery.actions';
import { PublicProofOfDeliveryState, PublicProofOfDeliveryStateModel } from './public-proof-of-delivery.state';
import {
  LoadDataFacade,
  ProofOfDeliveryDownloadFileParams,
  ProofOfDeliveryFacade,
  ProofOfDeliverySaveParams,
  SetInitialStateFacade,
} from '../../../../common';
import { MatDialogRef } from '@angular/material/dialog';

@Injectable({ providedIn: 'root' })
export class PublicProofOfDeliveryFacade implements LoadDataFacade, SetInitialStateFacade, ProofOfDeliveryFacade {
  proofOfDeliveryItemData$: Observable<PublicProofOfDeliveryStateModel> = this.store.select(
    PublicProofOfDeliveryState.getState,
  );
  loaded$: Observable<boolean> = this.store.select(PublicProofOfDeliveryState.getLoaded);

  constructor(private store: Store) {}

  loadAll(token: string): void {
    this.store.dispatch(new PublicProofOfDeliveryLoad(token));
  }

  saveProofOfDeliveryItem(params: ProofOfDeliverySaveParams): void {
    this.store.dispatch(new PublicProofOfDeliverySave(params));
  }

  downloadFile(params: ProofOfDeliveryDownloadFileParams): void {
    this.store.dispatch(new PublicProofOfDeliveryDownloadFile(params));
  }

  sendFeedback(data: { text: string }, token: string, dialogRef: MatDialogRef<unknown>): void {
    this.store.dispatch(new PublicProofOfDeliveryFeedback({ data, token, dialogRef }));
  }

  setInitialState(): void {
    this.store.dispatch(new PublicProofOfDeliveryInitialState());
  }
}
